import { createContext, useEffect, useRef, useState } from "react";

const MIN_ZOOM = .5
const MAX_ZOOM = 10

export const ExtractionContext = createContext();

export const ExtractionContextProvider = (props) => {
    // 输入图
    const [inputImage, setInputImage] = useState(props.inputImage)
    const [imageWidth, setImageWidth] = useState(props.imageWidth)
    const [imageHeight, setImageHeight] = useState(props.imageHeight)
    const [contentWidth, setContentWidth] = useState(0)
    const [contentHeight, setContentHeight] = useState(0)
    // 多语义分割mask
    const [multiMasks, setMultiMasks] = useState(props.multiMasks || [])
    // 交互式分割npy文件
    const [interactiveNpy, setInteractiveNpy] = useState(props.interactiveNpy)
    // 混合后的mask
    const [binaryMask, setBinaryMask] = useState(props.editedMask?.binaryMask)
    const binaryMaskOriginRef = useRef(props.editedMask?.binaryMask)
    const [modelBlendedMask, setModelBlendedMask] = useState()
    const [modelBlueMaskBase64, setModelBlueMaskBase64] = useState(props.editedMaskBase64?.foregroundAlphaMask)
    const modelBlueMaskBase64OriginRef = useRef(props.editedMaskBase64?.foregroundAlphaMask) // 原始的mask，如果下载时混合mask与原始mask一致，则没有改变

    /*********控制参数***********/
    // 交互式分割
    const [interactiveMode, setInteractiveMode] = useState("add") // add-增加 remove-减少
    // 涂抹选项
    const [paintMode, setPaintMode] = useState()
    const [paintSize, setPaintSize] = useState(20)
    const [eraseSize, setEraseSize] = useState(20)
    // 撤销/恢复
    const [undoList, setUndoList] = useState([]) // 待撤销列表
    const [redoList, setRedoList] = useState([]) // 待恢复列表
    // 移动控制
    const [viewportOffset, setViewportOffset] = useState({x: 0, y: 0})
    const [moveable, setMoveable] = useState(false)
    const [zoom, setZoom] = useState(1)

    useEffect(() => {
        setInputImage(props.inputImage)
    }, [props.inputImage])

    useEffect(() => {
        setImageWidth(props.imageWidth)
        setImageHeight(props.imageHeight)
    }, [props.imageWidth, props.imageHeight])
    
    useEffect(() => {
        setMultiMasks(props.multiMasks || [])
    }, [props.multiMasks])

    useEffect(() => {
        setBinaryMask(props.editedMask?.binaryMask)
        binaryMaskOriginRef.current = props.editedMask?.binaryMask
    }, [props.editedMask])

    useEffect(() => {
        setModelBlueMaskBase64(props.editedMaskBase64?.foregroundAlphaMask)
        modelBlueMaskBase64OriginRef.current = props.editedMaskBase64?.foregroundAlphaMask
    }, [props.editedMaskBase64])

    useEffect(() => {
        setInteractiveNpy(props.interactiveNpy)
    }, [props.interactiveNpy])

    return (
        <ExtractionContext.Provider value={{
            inputImage, setInputImage,
            imageWidth, setImageWidth,
            imageHeight, setImageHeight,
            contentWidth, setContentWidth,
            contentHeight, setContentHeight,
            multiMasks, setMultiMasks,
            binaryMask, setBinaryMask,
            binaryMaskOriginRef,
            modelBlendedMask, setModelBlendedMask,
            modelBlueMaskBase64, setModelBlueMaskBase64,
            modelBlueMaskBase64OriginRef,
            interactiveNpy, setInteractiveNpy,
            interactiveMode, setInteractiveMode,
            paintMode, setPaintMode,
            paintSize, setPaintSize,
            eraseSize, setEraseSize,
            undoList, setUndoList,
            redoList, setRedoList,
            viewportOffset, setViewportOffset,
            moveable, setMoveable,
            zoom, setZoom,
            MIN_ZOOM, MAX_ZOOM,
        }}>
            {props.children}
        </ExtractionContext.Provider>
    )
}